<script lang="ts" setup>
// Properties

// Data
</script>

<template>
    <div>
        <div class="font-bold text-black">The Teacher's Guide contains:</div>
        <ol class="ml-4 list-decimal">
            <li>Instruction and information on how to obtain your free digital coursebook codes</li>
            <li>
                Chart of Standards: a detailed description for teachers to make a more precise diagnosis of student's
                needs and assignments
            </li>
            <li>Chapter Reviews: bonus assessments for each chapter, which are reproducible</li>
            <li>Answer Key</li>
        </ol>
    </div>
</template>

<style scoped></style>
